import { get, post, put } from 'utils/methods';

export function addBoxApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/package-dimension`, data, headers);
}

export function editBoxApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/package-dimension`, data, headers);
}

export function getBoxesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}packages-dimension`, data, headers);
}
